export const DATE_SPAN = 'dateSpan';
export const TIME_SPAN = 'timeSpan';
export const DAYS_OF_WEEK = 'daysOfWeek';
export const DAYS_MONTHS = 'daysMonths';

export const rangeName = [
  'engine_rpm',
  'vehicle_speed',
  'engine_temperature',
  'fuel_level_liters',
  'fuel_level_perc',
  'battery_voltage',
  'throttle_position',
  'tachometer',
  'satellites_count',
  'altitude',
  'eco_drive',
  'temp1',
  'temp2',
  'ev_battery_level',
  'ev_range',
  'adblue_level_perc',
];
export const alarmKeys = ['alarm_name', 'date_time', 'date', 'time'];
export const vehicleKeys = [
  'vehicle_name',
  'licence_number',
  'vehicle_name_licence_number',
  'driver_name',
];
export const operationKeys = [
  'battery_voltage',
  'vehicle_speed',
  'engine_rpm',
  'throttle_position',
  'adblue_level_perc',
  'fuel_level_perc',
  'fuel_level_liters',
  'vehicleBatteryRange',
  'ev_battery_level',
  'mileage',
  'engine_temperature',
];
export const rideKeys = ['ride_privacy', 'eco_drive'];
export const indicationKeys = [
  'driver_seatbelt',
  'coolant_level',
  'oil_level',
  'check_engine',
  'esp_off',
  'ev_plugged_in',
  'ev_charging_start',
  'ignition',
  'doors',
];
export const accessoriesKeys = ['temp_1', 'temp_2'];
export const securityKeys = [
  'geofence',
  'remote_lock',
  'emulated_alarm',
  'unplug',
  'movement',
  'jamming',
];
export const drivingStyleKeys = ['eco_drive'];
export const positionKeys = [
  'waypoint',
  'waypoint_in',
  'waypoint_left',
  'waypoint_entered',
  'map_link',
  'altitude',
  'satellites_count',
  'latitude',
  'longitude',
];

export const waypointsKeys = ['waypoint_entered', 'waypoint_left', 'waypoint_in'];
export const doorsKeys = ['doors'];
export const radioBtnTooltipsTranslationKeys: {
  [key: string]: {
    '1': string;
    '2': string;
  };
} = {
  jamming: {
    '1': 'enum.alarms.jamming.intermediate.tooltip',
    '2': 'enum.alarms.jamming.total.tooltip',
  },
};
export const checkboxKeys = ['coolant_level_low', 'oil_level_low', 'check_engine'];
export const RULE_TYPE_BINARY_GROUP = 'binary_group';
export const RULE_TYPE_BINARY = 'binary';
export const RULE_TYPE_WAYPOINTS = 'waypoints';
export const RULE_TYPE_RANGE = 'range';
